import React, { useState } from "react";
import { Input } from "antd";
import { Search } from "lucide-react";

function SearchBar({ placeholder, searchHandler, filters, pagination }) {
  const [value, setValue] = useState("");

  const onSearchHandler = (val) => {
      searchHandler({
          ...filters,
          page: 1,
          paginate: pagination?.per_page || 10,
          keyword: val,
      });
  };

  return (
    <div className="w-full">
        <div className="relative flex items-center w-full rounded-lg border-2 border-gray-50 bg-gray-50
                        focus-within:border-emerald-500 focus-within:ring-emerald-500/50
                        focus-within:ring-2 focus-within:outline-none h-9
                      "
        >
            <Search className="absolute left-3 text-gray-400 w-4 h-4" />
            <Input
                placeholder={placeholder ?? "Keyword"}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onPressEnter={() => onSearchHandler(value)}
                allowClear
                variant="borderless"
                className="
                    pl-9 sm:pl-10
                    pr-3
                    text-[13px] sm:text-[14px]
                    placeholder:text-muted-foreground
                    disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50
                    bg-transparent
                "
            />
        </div>
    </div>
  );
}

export default SearchBar;
